<template>
  <ul class="navi-meta-list">
    <li
      v-for="option in props.listOptions"
      :key="option.name"
      class="navi-meta-list-item"
    >
      <component
        :is="NaviComponents[option.component]"
        v-bind="option.props"
      />
    </li>
  </ul>
</template>

<script setup>
import NaviLink from './NaviLink.vue'
import NaviLinkLogo from './NaviLinkLogo.vue'
import NaviButtonDropdown from './NaviButtonDropdown.vue'
import NaviButtonDropdownLinks from './NaviButtonDropdownLinks.vue'
import NaviButtonDropdownGroup from './NaviButtonDropdownGroup.vue'
import NaviLinkFeeds from './NaviLinkFeeds.vue'
import NaviButtonNotification from './NaviButtonNotification'
import NaviButtonSetting from './NaviButtonSetting.vue'
import NaviUserAuthLinks from './NaviUserAuthLinks.vue'

const NaviComponents = {
  NaviLink,
  NaviLinkLogo,
  NaviButtonDropdown,
  NaviButtonDropdownLinks,
  NaviButtonDropdownGroup,
  NaviLinkFeeds,
  NaviButtonNotification,
  NaviButtonSetting,
  NaviUserAuthLinks,
}

const props = defineProps({
  listOptions: {
    type: Array,
    required: true,
    validator(value) {
      return value.every((option) => (
        ['name', 'component', 'props'].every((requiredKey) => (
          Object.keys(option).includes(requiredKey)
        ))
      ))
    },
  },
})
</script>

<style scoped lang="scss">
.navi-meta-list {
  display: flex;
  list-style-type: none;

  .navi-meta-list-item {
    margin: 0;
    padding: 0;
  }
}
</style>
